import {
    CREATE_PRODUCT_DETAILS_REQUEST,
    CREATE_PRODUCT_DETAILS_SUCCESS,
    CREATE_PRODUCT_DETAILS_FAILURE,
    DELETE_PRODUCT_DETAILS_REQUEST,
    DELETE_PRODUCT_DETAILS_SUCCESS,
    DELETE_PRODUCT_DETAILS_FAILURE,
    FETCH_SINGLE_PRODUCT_DETAILS_REQUEST,
    FETCH_SINGLE_PRODUCT_DETAILS_SUCCESS,
    FETCH_SINGLE_PRODUCT_DETAILS_FAILURE,
    UPDATE_PRODUCT_DETAILS_REQUEST,
    UPDATE_PRODUCT_DETAILS_SUCCESS,
    UPDATE_PRODUCT_DETAILS_FAILURE,
    RESET_PRODUCT_DETAILS_INFO,
    CREATE_PRODUCT_DETAILS_FORM,
    UPDATE_PRODUCT_DETAILS_FORM,
    FETCH_PRODUCT_DATA_FROM_PROPERTY_SUCCESS,
    FETCH_PRODUCT_DETAILS_BY_ID_REQUEST,
    FETCH_PRODUCT_DETAILS_BY_ID_SUCCESS,
    FETCH_PRODUCT_DETAILS_BY_ID_FAILURE,
    FETCH_PRODUCT_DETAILS_REQUEST,
    FETCH_PRODUCT_DETAILS_SUCCESS
} from './productDetails.actionType';

export const PRODUCT_DETAILS = 'productDetails';

let initialState = {
    loading: false,
    productListDetails: [],
    productDetails: [],
    productType: [],
    productDetailsform: {},
    selectedState: {},
    errorMessage: ''
};

export let productDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRODUCT_DETAILS_BY_ID_REQUEST:
        case CREATE_PRODUCT_DETAILS_REQUEST:
        case UPDATE_PRODUCT_DETAILS_REQUEST:
        case FETCH_SINGLE_PRODUCT_DETAILS_REQUEST:
        case DELETE_PRODUCT_DETAILS_REQUEST:
        case FETCH_PRODUCT_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: true,
                productListDetails: updatePayload
            };
        case FETCH_PRODUCT_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                productDetails: updatePayload
            };
        case FETCH_PRODUCT_DATA_FROM_PROPERTY_SUCCESS:
            return {
                ...state,
                loading: false,
                productType: updatePayload
            };
        case CREATE_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                productDetailsform: {}
            };
        case UPDATE_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                productDetailsform: {}
            };
        case FETCH_SINGLE_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                productDetailsform: updatePayload
            };
        case DELETE_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                productDetailsform: {}
            };
        case RESET_PRODUCT_DETAILS_INFO:
            return {
                ...state,
                productDetailsform: {}
            };
        case CREATE_PRODUCT_DETAILS_FORM:
        case UPDATE_PRODUCT_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                productDetailsform: {
                    ...state.productDetailsform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PRODUCT_DETAILS_BY_ID_FAILURE:
        case CREATE_PRODUCT_DETAILS_FAILURE:
        case UPDATE_PRODUCT_DETAILS_FAILURE:
        case FETCH_SINGLE_PRODUCT_DETAILS_FAILURE:
        case DELETE_PRODUCT_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
